import React from "react";
import { KineticHero } from "@/components/KineticHero";
import { LeadMagnet } from "@/components/LeadMagnet";
import { TrustStrip, Services, HowItWorks, Marquee, Founders, FAQSection } from "@/components/Sections";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function HomePage() {
  usePageMeta({
    title: "One Partner. Every Financial Solution.",
    description: "Auxieron helps Indians build wealth with smarter investing — mutual funds, fixed income, insurance, tax planning, loans via lending partners and personalised financial planning. Bhubaneswar, India.",
    path: "/",
  });
  return (
    <>
      <KineticHero />
      <TrustStrip />
      <Services />
      <HowItWorks />
      <Marquee />
      <Founders />
      <LeadMagnet />
      <FAQSection limit={4} />
    </>
  );
}
